module.exports = __webpack_public_path__ + "static/media/maestro.270e85f7.svg";